import { render, staticRenderFns } from "./FinalDocument.vue?vue&type=template&id=4c84f356&"
import script from "./FinalDocument.vue?vue&type=script&lang=ts&"
export * from "./FinalDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports